import { Button, Paper } from "@mui/material";
import { Z_INDEX } from "constants/constants";
import { CUSTOMERS_MAX_LOT_DURATION } from "constants/customers";
import styled from "styled-components/macro";
import { useFlightTranslation } from "utils/customHooks/useFlightTranslation";
import { useCustomerKey } from "utils/customHooks/useCustomerKey";
import { ONE_DAY_OF_MS } from "utils/timeUtils";

export function PausedOverlay({ handleResume }) {
  const { translate } = useFlightTranslation();
  const ckey = useCustomerKey();
  const limitDays = (
    (CUSTOMERS_MAX_LOT_DURATION[ckey] || CUSTOMERS_MAX_LOT_DURATION.DEFAULT) /
    ONE_DAY_OF_MS
  ).toFixed(1);
  return (
    <PausedOverlayStyles>
      <Paper elevation={2}>
        <p>{translate("maximum_lot_duration_exceeded", "", { limitDays })}</p>
        <Button color="primary" variant="contained" onClick={handleResume}>
          {translate("resume")}
        </Button>
      </Paper>
    </PausedOverlayStyles>
  );
}
const PausedOverlayStyles = styled.div`
  position: absolute;
  z-index: ${Z_INDEX.L3};
  inset: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .MuiPaper-root {
    margin: 0 8px;
    padding: 8px 16px;
    background-color: hsla(0, 0%, 100%, 0.9);
    display: flex;
    gap: 12px;
    justify-content: space-between;
    align-items: center;
  }
  button {
    text-transform: none;
    color: white;
  }
`;
